import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import axios from 'axios';

import { FaMapLocationDot } from 'react-icons/fa6';
import MappedInTestFile from '../Wayfinder/MappedInTestFile';
import TestWayfinderImport from '../Wayfinder/TestWayfinderImport';
import WeatherApp from '../Wayfinder/WeatherApp';
import { getMapData, show3dMap } from "@mappedin/mappedin-js";
import Directory from '../Wayfinder/DummyCategory';

export default function ViewClientTable() {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState(''); // State to hold search input
  const [filteredClients, setFilteredClients] = useState([]);
  const [btn, setBtn] = useState(false);

  // Video and Map synchronization states
  const videoRef = useRef(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [mapAutoStart, setMapAutoStart] = useState(false);

  //////////////////////// Status On or Off state status//////////////////
  const [mergedClients, setMergedClients] = useState([]);
  const [clientSettings, setClientSettings] = useState([]);
  ///////////////////////////////////////////////////////////////////////





  // Fetch clients
  const fetchUsers = () => {
    fetch('/auth/users') // Update the URL to your API endpoint
      .then(response => response.json())
      .then(resp => {
        // Filter clients with role_id = 2
        const onlyClients = resp?.users?.filter(client => client.role === 2) ?? [];
        setClients(onlyClients);
      })
      .catch(error => console.error('Error fetching client data:', error));
  };




  //////////////////////// Status On or Off state status//////////////////
  // Fetch client settings
  const fetchClientSettings = async () => {
    try {
      const res = await axios.get('/auth/settings/client');
      const data = res.data.data ?? [];
      console.log('client Settings data', data);
      setClientSettings(data);
    } catch (error) {
      console.log(error);
    }
  };
  ///////////////////////////////////////////////////////////////////////

  useEffect(() => {
    // Fetch client data from the backend
    fetchUsers();
    fetchClientSettings();
  }, []);

  // Handle video metadata loaded
  const handleVideoLoadedMetadata = () => {
    if (videoRef.current) {
      const duration = videoRef.current.duration * 1000; // Convert to milliseconds
      setVideoDuration(duration);
      setIsVideoLoaded(true);
      console.log('Video loaded, duration:', duration, 'ms');
    }
  };

  // Handle video play
  const handleVideoPlay = () => {
    setIsPlaying(true);
    setMapAutoStart(true);
    console.log('Video started playing');
  };

  // Handle video pause
  const handleVideoPause = () => {
    setIsPlaying(false);
    console.log('Video paused');
  };

  // Handle video ended
  const handleVideoEnded = () => {
    setIsPlaying(false);
    console.log('Video ended');
  };

  // Start synchronized playback
  const startSynchronizedPlayback = () => {
    if (videoRef.current && isVideoLoaded) {
      videoRef.current.currentTime = 0; // Reset video to start
      videoRef.current.play();
    }
  };

  //////////////////////// Status On or Off state status//////////////////
  useEffect(() => {
    // If clients array is empty, still set mergedClients to [] so downstream is consistent
    const settingsMap = (clientSettings || []).reduce((acc, item) => {
      if (item?.clientId) acc[item.clientId] = item;
      return acc;
    }, {});

    console.log('settings map', settingsMap);

    const merged = (clients || []).map(client => {
      const s = settingsMap[client._id] || {};
      return {
        ...client,
        aihumanfeature: s.settings?.featureAccess?.aihEnabled ?? true,
        menufeature: s.settings?.featureAccess?.menuQuizEnabled ?? true,
        wayfinderfeature: s.settings?.featureAccess?.wayfinderEnabled ?? false,
      };
    });

    setMergedClients(merged);
    setFilteredClients(merged);
  }, [clients, clientSettings]);
  ///////////////////////////////////////////////////////////////////////

  // FILTER when searching
  useEffect(() => {
    const term = (search ?? '').toLowerCase().trim();

    if (!term) {
      setFilteredClients(mergedClients);
      return;
    }

    const result = (mergedClients || []).filter(client => {
      // const first = (client.first_name ?? "").toLowerCase();
      // const last = (client.last_name ?? "").toLowerCase();
      const company = (client.company_name ?? '').toLowerCase();
      const username = (client.username ?? '').toLowerCase();
      const email = (client.email ?? '').toLowerCase();
      const clientUrl = (client.client_url ?? '').toLowerCase();
      const menuClientUrl = (client.menu_client_url ?? '').toLowerCase();

      return (
        // first.includes(term) ||
        // last.includes(term) ||
        company.includes(term) ||
        username.includes(term) ||
        email.includes(term) ||
        clientUrl.includes(term) ||
        menuClientUrl.includes(term)
      );
    });

    setFilteredClients(result);
  }, [search, mergedClients]);

  // Delete user
  const deleteUser = async id => {
    const confirmDelete = window.confirm('Are you sure you want to delete this client?');
    if (!confirmDelete) return;
    try {
      await axios.delete(`/auth/deleteuser/${id}`);
      const updated = (mergedClients || []).filter(user => user._id !== id);
      setMergedClients(updated);
      setFilteredClients(updated);
    } catch (error) {
      console.error('Error deleting user:', error);
      alert('Failed to delete user');
    }
  };

  const copyClient = async userId => {
    try {
      await axios.post('/api/copy-client', { userId });
      fetchUsers();
    } catch (error) {
      console.error('Failed to save media data:', error);
    }
  };

  // Helper to show ON/OFF badge
  const statusBadge = isOn => (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '20px',
        borderRadius: '10px',
        fontSize: '11px',
        fontWeight: 'bold',
        color: '#fff',
        backgroundColor: isOn ? '#568244' : '#8B0000',
        marginRight: '8px',
        textTransform: 'uppercase',
      }}
    >
      {isOn ? 'ON' : 'OFF'}
    </span>
  );

  const columns = [
    // {
    //   name: "First Name",
    //   selector: (row) => row.first_name,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Last Name",
    //   selector: (row) => row.last_name,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: 'Company Name',
      selector: row => row.company_name,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Username',
      selector: row => row.username,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Email Address',
      selector: row => row.email,
      sortable: true,
      width: '250px',
    },
    // {
    //   name: 'Client URL',
    //   selector: row => row.client_url,
    //   sortable: true,
    // },
    {
      name: 'AI Human URL',
      cell: row => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {statusBadge(row.aihumanfeature)}
          <Link
            to={`/${row.client_url}`}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'blue',
              padding: '10px',
              borderRadius: '8px',
            }}
          >
            {row.client_url}
          </Link>
        </div>
      ),
      sortable: true,
      width: '250px',
    },
    {
      name: 'Menu URL',
      cell: row => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {statusBadge(row.menufeature)}
          <Link
            to={`/${row?.menu_client_url}`}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'blue',
              padding: '10px',
              borderRadius: '8px',
            }}
          >
            {row?.menu_client_url}
          </Link>
        </div>
      ),
      sortable: true,
      width: '250px',
    },

    {
      name: 'Action',
      cell: row => (
        <div
          className="action_sec"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '20px',
          }}
        >
          <div className="dropdown">
            <a
              className="btn btn-link font-24 p-0 line-height-1 no-arrow dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="dw dw-more"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right dropdown-menu-icon-list">
              <a className="dropdown-item" href={`/view-button-settings/${row?._id}`}>
                <i className="dw dw-edit2"></i> Menu's
              </a>
              <a className="dropdown-item" href={`/view-splash-settings/${row?._id}`}>
                <i className="dw dw-edit2"></i> Splash Screen
              </a>
              <a className="dropdown-item" href={`/global-settings/${row?._id}`}>
                <i className="dw dw-edit2"></i> Global Settings
              </a>
              <a className="dropdown-item" href={`/view-button-logs/${row?._id}`}>
                <i className="dw dw-edit2"></i> Interaction Report
              </a>
              <a className="dropdown-item" href={`/quiz-report/${row?._id}`}>
                <i className="dw dw-edit2"></i> Quiz Report
              </a>
              <a className="dropdown-item" href={`/view-avatar-settings/${row?._id}`}>
                <i className="dw dw-edit2"></i> AI Human
              </a>
              <a className="dropdown-item" href={`/availablity-settings/${row?._id}`}>
                <i className="dw dw-edit2"></i> System Settings
              </a>
              <a className="dropdown-item" href={`/trivia-quiz/${row?._id}`}>
                <i className="dw dw-edit2"></i> Trivia Quiz
              </a>

              {row.wayfinderfeature && (
                <Link className="dropdown-item" to={`/wayfinder/${row?._id}`}>
                  <i className="dw dw-edit2"></i> WayFinder
                </Link>
              )}
            </div>
          </div>

          <div
            className="copy_btn"
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() => copyClient(row?._id)}
          >
            <i className="dw dw-copy" style={{ fontSize: '18px', color: '#000' }}></i>
          </div>

          <div
            className="copy_btn"
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() => deleteUser(row?._id)}
          >
            <i className="dw dw-delete-3" style={{ fontSize: '18px', color: '#000' }}></i>
          </div>

          <Link to={`/add-client/${row?._id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div
              className="copy_btn"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <i className="fa fa-user" style={{ fontSize: '18px', color: '#000' }}></i>
            </div>
          </Link>
        </div>
      ),
      width: '350px',
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: 'bold', // Bold header text
        fontSize: '16px', // Increase font size
        backgroundColor: '#f4f4f4', // Light gray background
      },
    },
  };

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px">
          <div className="page-header">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="title">
                  <h4>View Clients</h4>
                </div>
              </div>
            </div>
          </div>

          <div className="card-box mb-30">
            <div className="pd-20"></div>
            <div className="pb-20">

              <input
                type="text"
                placeholder="Search Clients"
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{
                  marginBottom: '50px',
                  padding: '5px',
                  width: '30%',
                  float: 'right',
                }}
                className="form-control"
              />
              <DataTable
                columns={columns}
                data={filteredClients} // Use filtered data
                pagination
                highlightOnHover
                customStyles={customStyles} // Apply custom styles
                paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300, 350, 400, 450, 500]}
                paginationPerPage={50} // Set default records per page to 25
              />
            </div>
          </div>




          <div className="card-box mb-30">
            <div className="pd-20">
              {/* <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px',
                height: '100%'
              }}>
               
                <div style={{
                  backgroundColor: '#000',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <video
                    ref={videoRef}
                    autoPlay
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                    controls
                    onLoadedMetadata={handleVideoLoadedMetadata}
                    onPlay={handleVideoPlay}
                    onPause={handleVideoPause}
                    onEnded={handleVideoEnded}
                  >
                    <source src="/MappedIn-dummy.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>

                  
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    color: '#fff',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '12px'
                  }}>
                    📹 Navigation Video
                  </div>
                </div>

               
                <div
                id="mappedin-map"
                style={{
                  borderRadius: '10px',
                  overflow: 'hidden',
                  position: 'relative',
                  border: '2px solid #dee2e6',
                  width: '100%',
                  height: '100%'
                }}>
                  <MappedInTestFile
                    spaceName="Gothem News"
                    videoDuration={videoDuration || 45000}
                    brandColor="#127E10"
                    autoStart={false}  
                    videoPlaying={isPlaying}
                    onError={() => console.log('Map error')}
                    onAnimationStart={() => console.log('Map animation started')}
                    onAnimationComplete={() => console.log('Map animation completed')}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>




    </div>
  );
}
